$(document).ready(function(){
$('.play_pause .btn').click(function () {
   var mediaVideo = $(this).parents('.video_bannner').find(".video-homepage").get(0);
   if ($(this).hasClass('pause')) {
       mediaVideo.pause();
      $(this).parents('.video_bannner').find('.buttons_play_pause .pause').hide();
       $(this).parents('.video_bannner').find('.buttons_play_pause .play').show();
     mediaVideo.removeAttribute('controls');
   }else{
        mediaVideo.play();
       $(this).parents('.video_bannner').find('.buttons_play_pause .play').hide();
       $(this).parents('.video_bannner').find('.buttons_play_pause .pause').show();
     mediaVideo.removeAttribute('controls');
   }
});
$('.buttons_mute_sound .btn').click(function () {
   if ($(this).hasClass('mute')) {
       $(this).parents('.video_bannner').find(".video-homepage").prop('muted', true);
       $(this).parents('.video_bannner').find('.buttons_play_pause .mute').hide();
       $(this).parents('.video_bannner').find('.buttons_play_pause .unmute').show();
   }else{
        $(this).parents('.video_bannner').find(".video-homepage").prop('muted', false);
        $(this).parents('.video_bannner').find('.buttons_play_pause .unmute').hide();
       $(this).parents('.video_bannner').find('.buttons_play_pause .mute').show();
   }
   
});
});